module.exports = __webpack_public_path__ + "static/awards-logo4-a79a79a29ecb556c7c302d8999320393.jpg";